import { useEffect, useState } from 'react';
import type { Member } from '@tsuyosa/types';
import { getPublicMembers } from '@/lib/api';

export function MembersPage() {
  const [members,   setMembers]   = useState<Member[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error,     setError]     = useState('');

  useEffect(() => {
    getPublicMembers({ activity_status: 'active' })
      .then(setMembers)
      .catch((err) => setError(err instanceof Error ? err.message : 'Gagal memuat data'))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-5xl px-4 py-10">
      <h1 className="mb-6 text-2xl font-bold text-white">Member</h1>

      {isLoading && (
        <div className="flex justify-center py-20">
          <div className="h-7 w-7 animate-spin rounded-full border-2 border-[#f472b6] border-t-transparent" />
        </div>
      )}

      {error && (
        <p className="rounded-xl bg-red-500/10 px-4 py-3 text-sm text-red-400">{error}</p>
      )}

      {!isLoading && !error && (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {members.map((member) => (
            <div
              key={member.id}
              className="overflow-hidden rounded-xl border border-white/5 bg-[#130d1a] transition-colors hover:border-[#f472b6]/30"
            >
              <div className="aspect-[3/4] overflow-hidden bg-white/5">
                {member.profile_photo ? (
                  <img
                    src={member.profile_photo}
                    alt={member.nickname}
                    className="h-full w-full object-cover object-top"
                  />
                ) : (
                  <div className="flex h-full items-center justify-center text-4xl text-white/10">
                    ♡
                  </div>
                )}
              </div>
              <div className="p-4">
                <p className="font-semibold text-white">{member.nickname}</p>
                {member.full_name && (
                  <p className="mt-0.5 text-xs text-white/40">{member.full_name}</p>
                )}
                {member.positions.length > 0 && (
                  <p className="mt-1.5 text-[11px] text-[#f472b6]/70 capitalize">
                    {member.positions.slice(0, 2).map((p) => p.replace(/_/g, ' ')).join(' · ')}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {!isLoading && !error && members.length === 0 && (
        <p className="py-20 text-center text-sm text-white/30">Belum ada data member.</p>
      )}
    </div>
  );
}
